import styled from 'styled-components';
import { colorCSS } from '../../../styles';
export const Bar = styled.div `
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
export const Progress = styled.div `
  background: ${({ complete }) => complete
    ? colorCSS('G300')
    : `linear-gradient(
    90deg,
    ${colorCSS('T75')} 0%,
    ${colorCSS('T300')} 99%
  )`};
  height: 0.25rem;
  transition: width 0.2s ease;
`;
//# sourceMappingURL=ProgressBar.styles.js.map